export const assistantsId = {
  router: 'asst_MV7nFlGGTp16LVP5hFgXRzEb',
  reports: 'asst_HYr7mUPz0BdhZFvae4KpCRQY',
  ts_infections_biorisk: 'ts_infections_biorisk',
  table_disease_information: 'asst_G54JhZ3pckoUe3aLV1dWu5Rr',
  table_media: 'asst_ZqeqgW8LQ7B207NemU5FJDG5',
  table_press_releases: 'asst_Pik6se3doi48OK8FGcg3dCWU',
  single_report: 'asst_3OkZEtjEIQyA2cgnbTFKaz2G',
}
